import { Snackbar } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import BankService from "../../../services/PosService/BankService";
import Payement from "../../../services/Payement";
import { useNavigate } from "react-router-dom";

const AlimentationCaisse = ({ caisseInfo, setCaisseInfo }) => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [caissesAvailables, setCaissesAvailables] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  //alert
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setsuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  useEffect(() => {
    BankService.getAllCaissesByManager(getCurrentUserId())
      .then((response) => {
        if (response?.data?.success) {
          const mappedData = response?.data?.success.map((item) => ({
            value: item.idBankAccount,
            label: item.rib,
          }));
          setCaissesAvailables(mappedData);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :" + response?.data?.error);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  }, []);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCaisseInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onChangeSelected = (selectedOptionn) => {
    setSelectedOption(selectedOptionn);
  };
  const onValiderAlimentationCaisse = () => {
    let model = {
      idUser: getCurrentUserId(),
      amount: caisseInfo?.amount,
      idBankAccount: selectedOption?.value,
    };
    if (
      model.idBankAccount == null ||
      model.idBankAccount == "" ||
      (model.idBankAccount == undefined &&
        (model.amount == null || model.amount == ""))
    ) {
      setOpenErrorAlert(true);
      setErrorAlertText("remplir les champs !");
      return;
    } else if (model.amount == null || model.amount == "") {
      setOpenErrorAlert(true);
      setErrorAlertText("saisir le amount !");
      return;
    } else if (
      model.idBankAccount == null ||
      model.idBankAccount == "" ||
      model.idBankAccount == undefined
    ) {
      setOpenErrorAlert(true);
      setErrorAlertText("selectionner caisse !");
      return;
    } else {
      Payement.transfertAccountShop(model)
        .then((response) => {
          if (response?.data?.success || response?.status == "200") {
            setCaisseInfo([]);
            setSelectedOption("");
            setOpenSuccessAlert(true);
            setsuccessAlertText("ajouté avec succès !");
            navigate("/allBanqueAccounts-directeur");
          } else if (response?.data?.error) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :" + response?.data?.error);
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  };
  return (
    <section class="content" style={{ marginTop: "2%" }}>
      <div class="row">
        <div class="col-12">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">Alimenter caisse</h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                  title="Collapse"
                >
                  <i class="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Selectionner Caisse</label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={selectedOption}
                      onChange={onChangeSelected}
                      options={caissesAvailables}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>amount</label>
                    <input
                      name="amount"
                      type="number"
                      id="inputName"
                      className="form-control"
                      onChange={handleChange}
                      value={caisseInfo?.amount || ""}
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12" style={{ marginTop: "2%" }}>
                <button
                  className="btn btn-dark float-right"
                  onClick={onValiderAlimentationCaisse}
                >
                  Valider
                </button>
              </div>
            </div>

            <Snackbar
              open={openErrorAlert}
              autoHideDuration={2000}
              onClose={handleEroorClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert
                variant="filled"
                onClose={handleEroorClose}
                severity="error"
              >
                {errorAlertText}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSuccessAlert}
              autoHideDuration={2000}
              onClose={handleSuccessClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert
                variant="filled"
                onClose={handleSuccessClose}
                severity="success"
              >
                {successAlertText}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openInfoAlert}
              autoHideDuration={2000}
              onClose={handleInfoClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert variant="filled" onClose={handleInfoClose} severity="info">
                {infoAlertText}
              </Alert>
            </Snackbar>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AlimentationCaisse;
